import { graphql, useStaticQuery } from 'gatsby';

import propertiesService from '../service/properties-service';

export const usePageDynamicResults = (labels) => {
  const data = useStaticQuery(graphql`
    {
      allConfluencePage {
        edges {
          node {
            id
            title
            ancestors {
              id
              title
            }
            confluenceId
            confluenceChildren
            bodyHtml
            bodyDynamic
            bodyExport
            slug
            images
            labels {
              name
            }
            attachments {
              title
              _links {
                download
              }
              metadata {
                labels {
                  results {
                    label
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  let results = propertiesService.getAvailable(data.allConfluencePage.edges);

  if (labels) {
    results = propertiesService.getPagesWithLabels(results, labels);
  }

  return results;
};
